import React, { useState } from 'react';
import { Layout, AutoComplete, Input, message } from 'antd';
import { useNavigate } from 'react-router-dom';
import { gql, useLazyQuery } from '@apollo/client'; // Apollo hooks for GraphQL query
import '../styles/Header.css';

const { Header } = Layout;

// GraphQL query to search for articles
const SEARCH_ARTICLES_QUERY = gql`
  query listArticles($query: String!) {
    listArticles(where: { title: { contains: $query } }) {
    id
    title
    createdAt
  }
  }
`;

const AppHeader = () => {
  const [options, setOptions] = useState([]); // For search suggestions
  const navigate = useNavigate(); // To navigate to article details

  // Apollo lazy query hook to search articles
  const [searchArticles, { loading }] = useLazyQuery(SEARCH_ARTICLES_QUERY, {
    onCompleted: (data) => {
      // Map search results to AutoComplete options
      const searchResults = data.listArticles.map((article) => ({
        value: article.id,
        label: (
          <div>
            <strong>{article.title}</strong> <br />
            <small>{new Date(article.createdAt).toLocaleDateString()}</small>
          </div>
        ),
      }));
      setOptions(searchResults);
    },
    onError: (error) => {
      console.error('Error fetching search results:', error);
      message.error('Failed to fetch articles');
    },
  });

  // Function to handle search input change
  const onSearch = (value) => {
    if (value) {
      searchArticles({ variables: { query: value } }); // Execute GraphQL query with user input
    } else {
      setOptions([]); // Clear suggestions if input is empty
    }
  };

  // Function to handle article selection from search suggestions
  const onSelect = (article) => {
    navigate(`/articles/${article.id}`, { state: { article } });
  };

  return (
    <Header className="header-1">
      <div className="logo" onClick={() => navigate('/')} style={{ cursor: 'pointer' }}>
        <img src="/logo.png" alt="PROBONO Logo" className="logo-img" />
      </div>
      <div className="search-bar" id="header-search-bar">
        <AutoComplete
          options={options}
          onSearch={onSearch}
          onSelect={onSelect}
          style={{ width: 300 }}
          placeholder="Search articles..."
        >
          <Input.Search loading={loading} />
        </AutoComplete>
      </div>
    </Header>
  );
};

export default AppHeader;
